


























import { computed, defineComponent, PropType } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import { $t } from "@/lib/i18nHelpers";
import { PurchaseInfo } from "@/payments/types";
import { paymentMethodNames } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "PaymentConfirmation",
  components: { BaseConfirm, FormatMoney, BaseButton },
  props: {
    show: { type: Boolean, required: true },
    loading: { type: Boolean, required: true },
    paymentInfo: { type: Object as PropType<PurchaseInfo>, required: true },
    title: { type: String as PropType<TranslateResult | string>, default: $t("Payment confirmation") },
    buttonText: { type: String as PropType<TranslateResult | string>, default: $t("Pay now") },
  },
  setup(props) {
    const purchaseTypeNames = {
      one_time: $t("One time buy"),
      subscription: $t("Subscription"),
    };

    const details = computed(() => {
      return [
        { title: $t("Amount:"), value: props.paymentInfo.amount },
        { title: $t("Pay method:"), value: paymentMethodNames[props.paymentInfo.paymentMethod] },
        { title: $t("Purchase type:"), value: purchaseTypeNames[props.paymentInfo.purchaseType] },
      ];
    });

    return { details };
  },
});
